import MessageInputArea from './MessageInputArea';

export default MessageInputArea;
